export default __webpack_public_path__ + "static/search-536112df16ae06d4230d6d66e6325dab.jpg";